<app-breadcrumb [pathList]="pathList"></app-breadcrumb>
<div [ngBusy]="{busy: busy, message: 'Loading...', backdrop: false, delay: 0, minDuration: 600}"></div>
<div class="container-fluid">
    <app-single-season (pathListEvent)="loga($event)" [id]="id" [single]="single" [componentService]="realSeasonService" [routePart]="'real_season'" [part]="SeasonPart"></app-single-season>
    <app-alertbox #alertbox1 [alerts]=""></app-alertbox>
</div>